export const PRODUCTION_UNIT_DEFAULT_HEADERS = [
    'code',
    'city',
    'name',
    'startDate',
    'statusCode',
    'operator',
    'buildingOwner',
    'authorizedFlow',
    'volumeAllowDay',
    'max3hCapacity',
]

// L'objet renvoyé par le back est conservé tel quel (cf. ProductionUnitShape) ; on n'ajoute que les
// champs dérivés attendus par les composants génériques de station (carte, fiche, exports).
export const toProductionUnit = productionUnit => ({
    ...productionUnit,
    typeName: 'productionUnit',
    localisation: {
        x: productionUnit.x,
        y: productionUnit.y,
        z: productionUnit.z,
        projection: productionUnit.projection,
    },
    headers: PRODUCTION_UNIT_DEFAULT_HEADERS,
})
